import { useQuery } from "@tanstack/vue-query"
import { api } from "@/api"

type MerchantGroupSummaryReportResponse = {
  orderCount: {
    total: number
  }
  revenue: {
    total: number
    card: number
  }
}

const retrieveMerchantGroupSummaryReport = async () => {
  const { body } =
    await api.get<MerchantGroupSummaryReportResponse>(
      "/merchant-group/summary-report/",
      {
        isMerchantGroup: true,
      }
    )
  return body
}

export const useMerchantGroupSummaryReport = () =>
  useQuery(
    [BASE_MERCHANT_GROUP_SUMMARY_REPORT_QUERY_KEY] as const,
    () => retrieveMerchantGroupSummaryReport(),
    { refetchInterval: 60 * 1000 }
  )
